import { useAuth0 } from '@auth0/auth0-react'
import { Button, IconButton } from '@mui/material'
import { Logout as LogoutIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/system'
import { useCallback, useEffect, useState } from 'react'

export default function ImpersonateCheck(props) {
  const { t } = useTranslation()
  const [impersonate, setImpersonate] = useState()
  const { getAccessTokenSilently, logout } = useAuth0()

  useEffect(() => {
    setImpersonate(!!localStorage.getItem('impersonate'))
  }, [])

  const leaveFarm = useCallback(() => {
    if (impersonate === true) {
      const data = JSON.parse(
        localStorage.getItem(
          `@@auth0spajs@@::${AUTH_CID}::https://api.farmtrx.com::openid profile email offline_access`,
        ),
      )
      const otok = localStorage.getItem('otok')
      const updateData = update(data, {
        body: { access_token: { $set: otok } },
      })
      localStorage.setItem(
        `@@auth0spajs@@::${AUTH_CID}::https://api.farmtrx.com::openid profile email offline_access`,
        JSON.stringify(updateData),
      )
      localStorage.removeItem('impersonate')
      localStorage.removeItem('selectedClient')
      localStorage.removeItem('selectedFarms')
      localStorage.removeItem('otok')
      getAccessTokenSilently({ audience: 'https://api.farmtrx.com' })
        .then(() => {
          window.location.href = '/admin'
        })
        .catch((err) => {
          console.log('ERR => ', err)
          logout({ logoutParams: { returnTo: window.location.origin } })
        })
    }
  }, [getAccessTokenSilently, impersonate, logout])

  const altElement = props.showMessage ? (
    <StyledDiv>
      <span>{t('impersonating')}</span>
      <Button variant="contained" color="primary" onClick={leaveFarm}>
        {t('stop_impersonating')}
      </Button>
    </StyledDiv>
  ) : (
    <IconButton
      title={t('stop_impersonating')}
      onClick={leaveFarm}
      size="large"
    >
      <LogoutIcon />
    </IconButton>
  )

  return impersonate ? altElement : <>{props.children}</>
}

const StyledDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '1em',
})
